import React, { useId, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import type { Faq } from '../../types/content';
interface AccordionProps {
  items: Faq[];
  tone?: 'light' | 'dark';
  defaultOpen?: number | null;
}
export function Accordion({
  items,
  tone = 'light',
  defaultOpen = null
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  const baseId = useId();
  const dark = tone === 'dark';
  return <div className={`border-t ${dark ? 'border-white/15' : 'border-navy/15'}`} data-id="element-526" data-mp="3h001dzjt07g7">
      {items.map((item, i) => {
      const isOpen = open === i;
      const panelId = `${baseId}-panel-${i}`;
      const btnId = `${baseId}-btn-${i}`;
      return <div key={item.q} className={`border-b ${dark ? 'border-white/15' : 'border-navy/15'}`} data-id="element-527" data-mp="377aor1cionja" data-mpi={i}>
            <h3 data-id="element-528" data-mp="3uxerl6hvsj98">
              <button id={btnId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className={`flex w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-semibold uppercase tracking-wide md:text-xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-529" data-mp="3kbqh76hno9c">
                {item.q}
                <PlusIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-530" data-mp="36us0u309amyb" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-531" data-mp="3umh2i9yywnrx">
              {isOpen && <motion.div id={panelId} role="region" aria-labelledby={btnId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-532" data-mp="3ujl0oak01ey7">
                  <p className={`max-w-[60rem] pb-6 leading-relaxed ${dark ? 'text-chrome-300' : 'text-steel'}`} data-id="element-533" data-mp="44011okj9ago">{item.a}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}